import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import FocusLock from 'react-focus-lock';
import keyboardKey from 'keyboard-key';

import FilterPreview from '../../components/CollegeEventsFilterPreview';
import './styles.css';

const messages = defineMessages({
  newFilter: {
    id: 'collegeevents.filter.new',
    defaultMessage: '+ New Filter',
  },
  editFilter: {
    id: 'collegeevents.filter.edit',
    defaultMessage: 'Edit',
  },
});

const FilterList = ({ filters, searchText, onSelectionChange, onNewClick, focusLock, onClosePopup }) => {
  searchText = searchText.toLowerCase();
  const filterList = filters.filter((filter) => {
    const name = filter.name.toLowerCase();
    return name.includes(searchText);
  })
    .map((filter, index) => (
      <li role="option" aria-selected key={filter.id}>
        {/* eslint-disable-next-line  */}
          <button type="button" styleName="title-button" onClick={() => onSelectionChange(filter)} onKeyDown={event => onKeyDownRow(event, index, filter, 'row')}>
            <span styleName="filter-title">{filter.name}</span>
            <span styleName="filter-preview">
              <FilterPreview {...filter} />
            </span>
          </button>
      </li>
    ));

  const newLocationIndex = filterList.length + 1;
  const onKeyDownRow = (event, index, location, type) => {
    const code = keyboardKey.getCode(event);
    switch (code) {
      case keyboardKey.ArrowUp: {
        if (index === 0) {
          document.querySelector(`#eventFilter ul li:nth-child(${filterList.length+ 1}) > button`).focus();
          setTimeout(() => {
            document.querySelector(`#eventFilter ul li:nth-child(${filterList.length+ 1}) > button`).scrollIntoView();
          }, 50);
          return;
        }

        if (index === newLocationIndex && filterList.length !== 0) {
          document.querySelector(`#eventFilter ul li:nth-child(${filterList.length}) > button`).focus();
          return;
        }

        document.querySelector(`#eventFilter ul li:nth-child(${index}) > button`).focus();
        break;
      }
      case keyboardKey.ArrowDown:

        if (index === newLocationIndex) {
          document.querySelector('#eventFilter ul li:nth-child(1) > button').focus();
          setTimeout(() => {
            document.querySelector('#eventFilter ul li:nth-child(1) > button').scrollIntoView();
          }, 50);
          return;
        }
        document.querySelector(`#eventFilter ul li:nth-child(${index + 2}) > button`).focus();
        break;

      case keyboardKey.Enter: {
        if (type === 'row') {
          onSelectionChange(location);
        } else if (type === 'edit') {
          onNewClick();
        }
        break;
      }

      case keyboardKey.Escape: {
        onClosePopup();
        break;
      }
    }
  };
  return (
    <FocusLock returnFocus autoFocus disabled={focusLock}>
      <ul styleName="filter-list">
        {filterList}
        <li>
          <button
            type="button"
            styleName="title-button new-button"
            onClick={() => onNewClick()}
            onKeyDown={(event) => onKeyDownRow(event, newLocationIndex, null, 'edit')}
          >
            <FormattedMessage id="amevents.filter.new" {...messages.newFilter} />
          </button>
        </li>
      </ul>
    </FocusLock>
  );
};

FilterList.propTypes = {
  filters: PropTypes.array.isRequired,
  searchText: PropTypes.string.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onNewClick: PropTypes.func.isRequired,
  focusLock: PropTypes.bool,
  onClosePopup: PropTypes.func.isRequired,
};

export default FilterList;
